import React from 'react'
import { useSelector } from "react-redux";
import { selectAllUsers, selectAllParticipants } from "./usersSlice";
import { Link } from 'react-router-dom';


function UsersList() {
  const users = useSelector(selectAllUsers);
  console.log(users)
  const renderedUsers = users.map((user) => (
    <li key={user.id}>
      <Link to={`/users/${user.id}`}>{user.name}</Link>  {/* //changed from user */}
    </li>
  ))

  return (
    <section>
      <h1>Users List</h1>
      {renderedUsers}
    </section>
  )
}

export default UsersList